export default "__VITE_ASSET__DbA7SIlu__"